import { Injectable } from '@angular/core';
import { TokenService, HttpService, AESService } from '../../services/index';
import { environment as env } from 'src/environments/environment';
import { BehaviorSubject } from 'rxjs';

@Injectable({
    providedIn: 'root'
})
export class MerchantService {

    private merchantIdSubject = new BehaviorSubject<number | null>(null);
    public merchantId$ = this.merchantIdSubject.asObservable();

    private merchantCodeSubject = new BehaviorSubject<string | null>(null);
    public merchantCode$ = this.merchantCodeSubject.asObservable();

    constructor(
        private tokenService: TokenService,
        private aesService: AESService
    ) { }

    getMerchantCode(): string {
        // const encryptedMerchantCode = this.tokenService.getLocalToken(env.TokenKeys.MerchantCode) ?? '';
        // const merchantCode = this.aesService.decrypt(encryptedMerchantCode);
        // this.merchantCodeSubject.next(merchantCode);

        const merchantCode = this.tokenService.getLocalToken(env.TokenKeys.MerchantCode) ?? '';
        this.merchantCodeSubject.next(merchantCode);
        return merchantCode;
    }

    getMerchantId(): number {
        // const encryptedMerchantId = this.tokenService.getLocalToken(env.TokenKeys.MerchantId) ?? '';
        // const decrypted = this.aesService.decrypt(encryptedMerchantId);

        const merchantIdToken = this.tokenService.getLocalToken(env.TokenKeys.MerchantId) ?? '';
        const merchantId = Number(merchantIdToken);
        this.merchantIdSubject.next(merchantId);
        return merchantId;
    }
    
    updateMerchantInfo() {
        const code = this.getMerchantCode();
        const id = this.getMerchantId();

        this.merchantCodeSubject.next(code);
        this.merchantIdSubject.next(id);
    }
}
